import smurf from "./smurf.png"
import thor from "./thor.png"
import wizardOriginal from "./wizard-original.png"
import wonderWoman from "./wonder-woman.png"

export default {
  smurf,
  thor,
  wizardOriginal,
  wonderWoman
};